// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import { useMenu } from "../../../../hooks/useMenu";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const items = useMenu();
  const navItems = items.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
